import { render, staticRenderFns } from "./LoanDetails.vue?vue&type=template&id=02c2e65e&scoped=true&"
import script from "./LoanDetails.vue?vue&type=script&lang=js&"
export * from "./LoanDetails.vue?vue&type=script&lang=js&"
import style0 from "./LoanDetails.vue?vue&type=style&index=0&id=02c2e65e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c2e65e",
  null
  
)

export default component.exports